import { render, staticRenderFns } from "./ViewDispAnclajePage.vue?vue&type=template&id=7d572d96"
import script from "./ViewDispAnclajePage.vue?vue&type=script&lang=js"
export * from "./ViewDispAnclajePage.vue?vue&type=script&lang=js"
import style0 from "./ViewDispAnclajePage.vue?vue&type=style&index=0&id=7d572d96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports